module.exports = __webpack_public_path__ + "img/banner_1.64b6b34f.webp";